export default __webpack_public_path__ + "static/media/assisted-onboarding-card.f3b2dbaf.png";